import { createFormStmtInstruction } from './CreateFormStmt';
import { createInsideFormStmtInstruction } from './CreateInsideFormStmt';
import { removeFormStmtInstruction } from './RemoveFormStmt';
import { sortFormFieldsStmtInstruction } from './SortFormFieldsStmt';
export const formInstruction = `
## Form
Form is a collection of fields that are used to collect data from the user. Forms are used to create or update data in the system. Form is always a part of a scope that defines the context of the form.

### Form commands

${createFormStmtInstruction}
${removeFormStmtInstruction}
${createInsideFormStmtInstruction}
${sortFormFieldsStmtInstruction}
`;
//# sourceMappingURL=formInstruction.js.map